import { ArrowRightIcon } from "@heroicons/react/20/solid";

const BudgetPaginationButton = ({
  placeholderText,
  activeText,
  onClick,
  showActiveText,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={showActiveText}
      className={`mt-16 flex w-full items-center justify-center rounded-2xl py-4
        px-6 text-center font-sen transition-all duration-300 ease-in-out
        ${
          showActiveText
            ? "bg-primary text-white"
            : "bg-light-background text-disabled"
        }`}
    >
      {showActiveText ? (
        <span className="flex items-center space-x-2">
          <span className="transition-all duration-300">{activeText}</span>
          <ArrowRightIcon
            className={`h-5 w-5 transition-transform duration-300 ease-in-out ${
              showActiveText ? "translate-x-1" : "translate-x-0"
            }`}
          />
        </span>
      ) : (
        <span className="transition-opacity duration-300 ease-in-out">
          {placeholderText}
        </span>
      )}
    </button>
  );
};

export default BudgetPaginationButton;
